export const EMPTY_LABEL = '---'
export const SUBMIT_ALL_DOCUMENT_BUTTON_ID = 'submit-all-documents'
export const MAX_FILES_PER_DOCUMENT = 3
export const MAX_FILES_FOR_STAFF_ONLY_DOCUMENT = 1

